module.exports = "/_next/static/images/receive-a2644add4244a087723df152b9857939.svg";